import { c as _c } from "react/compiler-runtime";
/* eslint-disable @next/next/no-img-element */
import { Button } from '@common/components';
import dayjs from 'dayjs';
import { CustomLink } from '@/app/_components/CustomLink';
interface ReviewItemProps {
  logoUrl: string;
  mainImageUrl: string;
  institutionName: string;
  title: string;
  createdAt?: string;
  editHref?: string;
}
export const ReviewItem = t0 => {
  const $ = _c(27);
  const {
    logoUrl,
    mainImageUrl,
    institutionName,
    title,
    createdAt,
    editHref
  } = t0;
  let t1;
  if ($[0] !== mainImageUrl || $[1] !== title) {
    t1 = <img src={mainImageUrl} alt={title} className="size-104 shrink-0 rounded-large border-1 border-Gray-300" />;
    $[0] = mainImageUrl;
    $[1] = title;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== institutionName || $[4] !== logoUrl) {
    t2 = <img src={logoUrl} alt={institutionName} className="block size-20 shrink-0 rounded-pill border-1 border-Gray-300 object-cover" />;
    $[3] = institutionName;
    $[4] = logoUrl;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== institutionName) {
    t3 = <p className="max-w-full truncate font-600 text-Gray-600 typo-caption1">{institutionName}</p>;
    $[6] = institutionName;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t2 || $[9] !== t3) {
    t4 = <div className="flex items-center gap-2">{t2}{t3}</div>;
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== title) {
    t5 = <p className="line-clamp-2 text-ellipsis font-500 text-Gray-900 typo-body4">{title}</p>;
    $[11] = title;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== createdAt) {
    t6 = createdAt ? <p className="font-400 text-Gray-550 typo-caption1">{dayjs(createdAt).format("YYYY.MM.DD")}</p> : null;
    $[13] = createdAt;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== editHref) {
    t7 = editHref ? <CustomLink href={editHref}><Button theme="sub-line" dimensions="H32">수정</Button></CustomLink> : null;
    $[15] = editHref;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== t6 || $[18] !== t7) {
    t8 = <div className="mt-auto flex items-center justify-between">{t6}{t7}</div>;
    $[17] = t6;
    $[18] = t7;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t9;
  if ($[20] !== t4 || $[21] !== t5 || $[22] !== t8) {
    t9 = <div className="flex min-w-0 grow flex-col gap-4">{t4}{t5}{t8}</div>;
    $[20] = t4;
    $[21] = t5;
    $[22] = t8;
    $[23] = t9;
  } else {
    t9 = $[23];
  }
  let t10;
  if ($[24] !== t1 || $[25] !== t9) {
    t10 = <div className="flex gap-16">{t1}{t9}</div>;
    $[24] = t1;
    $[25] = t9;
    $[26] = t10;
  } else {
    t10 = $[26];
  }
  return t10;
};